<div>
    <div>
        <ng-template pTemplate='header'>
            <ui-page-title [title]="'hrMasterDataRecordHistory.recordHistory' | translate"></ui-page-title>
        </ng-template>
        <p-table
            styleClass="p-datatable-striped"
            id = "hr_master_data_record_history_list"
            [value]="listData"
        >
            <ng-template pTemplate="header">
                <tr>
                    <th>
                        {{ 'hrMasterDataRecordHistory.createdBy' | translate }}
                    </th>
                    <th>
                        {{ 'hrMasterDataRecordHistory.dateCreated' | translate }}
                    </th>
                    <th>
                        {{ 'hrMasterDataRecordHistory.updatedBy' | translate }}
                    </th>
                    <th>
                        {{ 'hrMasterDataRecordHistory.dateUpdated' | translate }}
                    </th>

                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-record>
                <tr>
                    <td>{{ record.createdBy }}</td>
                    <td>{{ record.dateCreated |  dateConvert  }}</td>
                    <td>{{ record.updatedBy }}</td>
                    <td>{{ record.dateUpdated | dateConvert }}</td>

                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="4">{{ 'hrMasterDataRecordHistory.noRecordsFound' | translate }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>

</div>
